import React from "react";

const ICONS = {
  info: "ri-information-line",
  warning: "ri-error-warning-line",
  danger: "ri-lock-line",
  secure: "ri-lock-line",
};

/** Small coloured note under a question: info (blue), warning (amber), danger (red), secure (blue lock). */
function InfoNote({ tone = "info", children }) {
  return (
    <div className={`kv-note kv-note--${tone}`}>
      <i className={ICONS[tone] || ICONS.info} aria-hidden="true" />
      <p>{children}</p>
    </div>
  );
}

export default InfoNote;
